import Vue from 'vue';
import Vuex from 'vuex';

import itemsListModule from './modules/itemsList.store';
import historicModule, { writeHistoricToLocaleStorage } from './modules/historic.store';

Vue.use(Vuex);

export const ITEMS_LIST_MODULE_NAME = 'itemsList';
export const HISTORIC_MODULE_NAME = 'historic';

const store = new Vuex.Store({
    modules: {
        [ITEMS_LIST_MODULE_NAME]: itemsListModule,
        [HISTORIC_MODULE_NAME]: historicModule,
    },
    actions: {
        initializeStores({commit}) {
            commit(HISTORIC_MODULE_NAME + '/initializeStore');
        }
    },
    strict: import.meta.env.DEV
});

store.subscribe((mutation, state) => {
    if (mutation.type.startsWith(HISTORIC_MODULE_NAME + '/')){
        writeHistoricToLocaleStorage(state[HISTORIC_MODULE_NAME].historic);
    }
});

export default store;
export const useStore = () => store
